import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../authentication/services/authentication.service';
import { TitleService } from '@core/navigation/services/title.service';
import { environment } from '@env';
import { MatSidenavContainer, MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { MenuComponent } from '../menu/menu.component';
import { NgIf, TitleCasePipe } from '@angular/common';
import { AntEnvironmentIndicatorModule } from '@antony/ng-core';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { AntButtonModule } from '@antony/ng-ui';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { ProfileComponent } from '../profile/profile.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  imports: [
    MatSidenavContainer,
    MatSidenav,
    MenuComponent,
    MatSidenavContent,
    NgIf,
    AntEnvironmentIndicatorModule,
    MatToolbar,
    MatIcon,
    AntButtonModule,
    BreadcrumbsComponent,
    ProfileComponent,
    TitleCasePipe,
    TranslatePipe,
  ],
})
export class NavigationComponent implements OnInit {
  showProfile = false;
  environment = environment;

  constructor(
    protected authService: AuthenticationService,
    protected titleService: TitleService
  ) {}

  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  ngOnInit(): void {}

  getTitle(): string {
    return this.titleService.getTitleWithUpdate();
  }
}
